
import fetchInterceptor, { FetchOptions } from '../../../utils/fetchInterceptor ';
import { IGetLiability } from '../ILiability';
import { getLiabilityEp as endpoint } from '../apiEndpoints';
const GetLiabilityAPI = async ({ header }: IGetLiability) => {
    const url = endpoint()
    const options: FetchOptions = {
        method: "GET",
        headers: header,
    }

    return fetchInterceptor(url, options)

};

export default GetLiabilityAPI;